var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"d-flex min-vh-100 justify-content-center flex-column"},[_c('Loader')],1):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }